document.addEventListener("DOMContentLoaded", function() {
  const LS_KEY = "zoneInfo";

  // --- Storage (read once, keep in memory) ---
  function getSaved() {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || "null"); } catch(e) { return null; }
  }
  let zoneInfo = getSaved(); // cache

  // --- Header update (light + capped retry) ---
  function updateHeader() {
    const display = zoneInfo && zoneInfo.display ? zoneInfo.display : "Select a zone";
    const spans = document.querySelectorAll(".zone-value");
    if (!spans.length) return false;
    spans.forEach(s => {
      if (zoneInfo?.display || !s.textContent || /select a zone/i.test(s.textContent)) {
        s.textContent = display;
      }
    });
    return true;
  }

  // Retry up to ~1s for late-mounted headers (no subtree observe)
  (function retryHeader(attempts){
    if (updateHeader()) return;
    if (attempts <= 0) return;
    requestAnimationFrame(() => retryHeader(attempts - 1));
  })(60); // ~60 frames ≈ 1s cap

  // Keep in sync if user set a new zone on another page/tab
  window.addEventListener("storage", (ev) => {
    if (ev.key !== LS_KEY) return;
    zoneInfo = getSaved();
    updateHeader();
    hydrateAllProductForms();
  });

  // React to your checker’s custom event (same tab)
  window.addEventListener("zone:updated", (ev) => {
    zoneInfo = ev.detail || getSaved();
    updateHeader();
    hydrateAllProductForms();
    const warn = document.getElementById("zone-cart-warning");
    if (warn) warn.remove();
  });

  // --- Product forms: add hidden attribute once ---
  function setGrowingZoneHiddenInput(form) {
    if (!(zoneInfo && zoneInfo.display)) return;
    let input = form.querySelector('input[name="attributes[Growing Zone]"]');
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "attributes[Growing Zone]";
      input.id = "attr-growing-zone";
      form.appendChild(input);
    }
    input.value = zoneInfo.display;
  }

  function hydrateAllProductForms() {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    if (!forms.length) return;
    forms.forEach(setGrowingZoneHiddenInput);
  }
  hydrateAllProductForms();

  /*
  // --- Guard add-to-cart (no heavy work) ---
  function ensureZoneBeforeAdd(e) {
    if (!(zoneInfo && zoneInfo.display)) {
      e.preventDefault();
      const form = e.target.closest('form[action*="/cart/add"]') || e.target.form;
      if (form && !document.getElementById("zone-cart-warning")) {
        const warn = document.createElement("div");
        warn.id = "zone-cart-warning";
        warn.style.margin = "1rem 0";
        warn.style.color = "#d9534f";
        warn.innerHTML = `Please select your <a href="/pages/zones" style="color:#d9534f; text-decoration:underline;">zone</a> before adding to cart.`;
        (form.querySelector('[name="add"]') || form).insertAdjacentElement("afterend", warn);
      }
      return false;
    }
    const form = e.target.closest('form[action*="/cart/add"]') || e.target.form;
    if (form) setGrowingZoneHiddenInput(form);
    const warn = document.getElementById("zone-cart-warning");
    if (warn) warn.remove();
    return true;
  }*/

  document.addEventListener("click", function(e) {
    const addBtn = e.target.closest('[name="add"], button[type="submit"][name="add"]');
    if (!addBtn) return;
    ensureZoneBeforeAdd(e);
  }, true);

  document.addEventListener("submit", function(e) {
    if (!e.target.matches('form[action*="/cart/add"]')) return;
    if (!ensureZoneBeforeAdd(e)) return;
  }, true);
});